"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTracking } from "react-tracking";
import { Stack, FormControlLabel, FormHelperText } from "@mui/material";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { CheckboxIndeterminate, CheckboxUnchecked, CheckboxChecked } from "@nxt-costco-com/forge-icons";
import { COMPONENT_NAME } from "./constants.js";
import { StyledCheckbox, getCheckBoxStyles, StyledLabel } from "./styles.js";
import { InputError } from "../InputError/index.js";
const Checkbox = ({
  ariaDescribeText = "",
  errorText,
  hasError = false,
  helptext,
  id = "",
  isChecked,
  isEmphasized = false,
  isIndeterminate = false,
  label = "",
  value,
  variant = "l1",
  onChange,
  handleFocus,
  handleBlur,
  suffix = "",
  inputRef,
  additionalField,
  isShowHideAdditionalField = false
}) => {
  const { trackEvent } = useTracking();
  const styles = getCheckBoxStyles({
    hasError,
    isEmphasized,
    isChecked
  });
  const errorSuffix = suffix ? `error_message_${suffix}` : `error_message`;
  const helptextSuffix = suffix ? `helptext_message_${suffix}` : `helptext_message`;
  const ariaDescribeBy = [
    hasError ? errorSuffix : "",
    helptext ? helptextSuffix : "",
    ariaDescribeText ? ariaDescribeText : ""
  ].join(" ").trim();
  const onChangeHandler = (event, isCurrChecked) => {
    trackEvent();
    onChange == null ? void 0 : onChange(event, isCurrChecked);
  };
  const checkboxAttributes = {
    "data-testid": COMPONENT_NAME,
    checked: isChecked,
    checkedIcon: /* @__PURE__ */ jsx(CheckboxChecked, {}),
    disableRipple: true,
    hasError,
    icon: /* @__PURE__ */ jsx(CheckboxUnchecked, {}),
    id,
    value,
    indeterminate: isIndeterminate,
    indeterminateIcon: /* @__PURE__ */ jsx(CheckboxIndeterminate, {}),
    isEmphasized,
    isIndeterminate,
    onChange: onChangeHandler
  };
  if (!label) {
    return /* @__PURE__ */ jsx(
      StyledCheckbox,
      {
        ...checkboxAttributes,
        slotProps: {
          input: {
            "aria-describedby": ariaDescribeText,
            "aria-invalid": hasError,
            ref: inputRef,
            value
          }
        },
        onFocus: handleFocus,
        onBlur: handleBlur
      }
    );
  }
  return /* @__PURE__ */ jsxs(Stack, { gap: SpaceXxs, children: [
    /* @__PURE__ */ jsx(
      FormControlLabel,
      {
        control: /* @__PURE__ */ jsx(
          StyledCheckbox,
          {
            ...checkboxAttributes,
            sx: styles.labelCheckbox,
            slotProps: {
              input: {
                "aria-describedby": hasError || helptext || ariaDescribeText ? ariaDescribeBy : void 0,
                "aria-invalid": hasError || void 0,
                ref: inputRef,
                value
              }
            },
            onFocus: handleFocus,
            onBlur: handleBlur
          }
        ),
        label: /* @__PURE__ */ jsx(StyledLabel, { variant, children: label }),
        sx: styles.label,
        htmlFor: id
      }
    ),
    /* @__PURE__ */ jsx(
      InputError,
      {
        errorIconA11yAttributes: {
          "aria-hidden": false,
          focusable: true,
          "aria-label": "Error"
        },
        errorTextId: errorSuffix,
        hasError,
        testId: errorSuffix,
        errorText
      }
    ),
    helptext && /* @__PURE__ */ jsx(FormHelperText, { id: helptextSuffix, sx: styles.helpertext, children: helptext }),
    (isChecked && isShowHideAdditionalField || !isShowHideAdditionalField) && additionalField
  ] });
};
Checkbox.displayName = COMPONENT_NAME;
export {
  Checkbox
};
